/**
 * Wrapper Icon Button for the design library button to pass our router specific link
 */

import { type ExoticComponent, forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { IconButton as DesignLibraryIconButton } from '@mweb/zappos-ui/IconButton';
import type { IconButtonProps, IconButtonVariant } from '@mweb/zappos-ui/IconButton';

import { cn } from 'helpers/classnames';

const rebrandIconButtonClasses: Record<IconButtonVariant, string> = {
  filled: 'zappos:bg-gray-900 zappos:hover:bg-gray-700',
  outlined: 'zappos:text-gray-900 zappos:hover:text-gray-700 zappos:hover:border-gray-700',
  filledModerate: 'zappos:text-gray-900 zappos:hover:bg-gray-200',
  outlinedLight: 'zappos:text-gray-0 zappos:hover:text-gray-100 zappos:hover:border-gray-100',
  icon: 'text-gray-900 zappos:hover:text-gray-600'
} as const;

const IconButton = forwardRef<HTMLButtonElement, Omit<IconButtonProps, 'linkComponent' | 'linkProps'>>(
  ({ className, href, variant, ...rest }, ref) => (
    <DesignLibraryIconButton
      {...rest}
      ref={ref}
      className={cn(className, rebrandIconButtonClasses[variant])}
      href={href}
      linkComponent={Link as ExoticComponent}
      linkProps={{ to: href }}
      variant={variant}
    />
  )
);

export default IconButton;
